<template>
  <span>
    <disabled-tips :show-tip="readonly" :tip="tip">
      <a
        slot="content"
        class="custom-a"
        :href="!readonly ? href : undefined"
        :class="readonly ? 'readonly' : ''"
        :target="target"
        @click.prevent="router($event)"
      >
        {{ text }}
      </a>
    </disabled-tips>
  </span>
</template>

<script>
export default {
  name: 'custom-a',
  props: {
    text: {
      type: String,
      default() {
        return undefined
      },
    },
    tip: {
      type: String,
      default() {
        return undefined
      },
    },
    href: {
      type: String,
      default() {
        return ''
      },
    },
    readonly: {
      type: [Number, Boolean],
      default() {
        return false
      },
    },
    target: {
      type: String,
      default() {
        return ''
      },
    },
  },
  methods: {
    router($e) {
      if (this.href && !this.readonly) {
        if ($e.ctrlKey || $e.metaKey || this.target === '_blank') {
          window.open(this.href)
        } else {
          this.$router.push(this.href)
        }
      }
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus">
a
  &.custom-a
    margin-right: 8px;
  &.readonly
    color: #68696b!important;
    cursor: not-allowed;
</style>
